// extracted by mini-css-extract-plugin
module.exports = {"button":"capacitor-BackButton__button--2MxLi","icon":"capacitor-BackButton__icon--IS3x2"};